import * as HTTP from './http';

export const List = token => HTTP.GET('tracking-access', token);
export const Create = (token, data) => HTTP.POST('tracking-access', data, token);
export const Update = (token, id, data) => HTTP.PATCH(`tracking-access/${id}`, data, token);
export const Activate = (token, id, data) => HTTP.POST(`tracking-access/${id}/activate`, data, token);
export const Deactivate = (token, id, data) => HTTP.POST(`tracking-access/${id}/deactivate`, data, token);
export const History = (token, id) => HTTP.GET(`tracking-access/${id}/history`, token);
